import { MODULE_NAME } from './module';

export const createRebateBillScope = (billId: string) => `${MODULE_NAME}-${billId}`;
